import React from "react";

// FIXME this vs import { FormattedNumber } from 'react-intl'
export default class FormattedNumber extends React.Component {
  format(value) {
    return value.toFixed(2).replace(".", ",");
  }

  render() {
    const numberValue = this.format(this.props.value);

    return <span>{numberValue}</span>;
  }
}
